<template>
  <div>
    <v-row>
      <v-app-bar v-if="$store.state.userId" color="#fff" class="top-App-bar-saba">
        <div>
          <router-link to="/">
            <img src="../assets/image/logo.png" class="top-logo-saba"/>
          </router-link>
        </div>
        <div class="logo-text-saba">
          <router-link to="/">
            <p>اتوماسیون اداری صبا
              <br>
              نسخه 1.1</p>
          </router-link>
        </div>
        <v-spacer>

        </v-spacer>
        <div class="left-top-header">


          <ProfileForm @get="getProfileData"></ProfileForm>
          <v-btn v-if="profile" color="#4abbcb" dark class="header-btn">سطح کاربری : {{ profile.post }}</v-btn>
          <v-btn @click="$store.state.editProfile=true" small icon class="header-icon">
            <v-icon>{{ icons.mdiCogOutline }}</v-icon>
          </v-btn>
          <v-badge
              v-if="unreadmessages"
              color="green"
              :content="unreadmessages"
              :value="unreadmessages"
              overlap
          >
          <v-btn to="/message" small icon class="header-icon">
            <v-icon>{{ icons.mdiBellRingOutline }}</v-icon>
          </v-btn>
          </v-badge>
          <v-btn @click="logout" icon small class="header-icon">
            <v-icon>{{ icons.mdiPower }}</v-icon>
          </v-btn>


        </div>
      </v-app-bar>
    </v-row>

    <v-row>
      <v-col v-if="$store.state.userId" lg="3" sm="6" cols="12">
        <div class="right-menu-saba" v-if="profileLoaded">
          <img v-if="profile.image" :src="$store.state.file+profile.image" class="avatar-saba"/>
          <img v-else src="../assets/image/users.png" class="avatar-saba"/>
          <div>
            <h3 v-if="profile.userType==='person'" >{{ profile.fName }} {{ profile.lName }} </h3>
            <h3 v-if="profile.userType==='company'" > {{ profile.coName }}</h3>
            <p v-if="profile.userType==='person'" >{{ profile.post }}</p>
            <p v-if="profile.userType==='company'" >{{ profile.fName }} {{ profile.lName }} (متصدی)</p>
          </div>

          <v-list-item to="/" dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Dashborad.png"/>
            <span class="menu-item-saba-text">
                       داشبورد
                   </span>
          </v-list-item>
          <v-list-item v-if="!(profile.roleLevel==5)" to="/contracts" dense active-class="menu-active"
                       class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Contract.png"/>
            <span class="menu-item-saba-text">
                       قراردادها
                   </span>
          </v-list-item>
          <v-list-item v-if="!(profile.roleLevel==4)" to="/publish" dense active-class="menu-active"
                       class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Publishers.png"/>
            <span class="menu-item-saba-text">
                       انتشارات
                   </span>
          </v-list-item>
          <v-list-item v-if="(profile.roleLevel==1) || (profile.roleLevel==2) || (profile.roleLevel==3)"
                       to="/distribute" dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Distribution.png"/>
            <span class="menu-item-saba-text">
                       توزیع
                   </span>
          </v-list-item>
          <v-list-item v-if="(profile.roleLevel==1) || (profile.roleLevel==2) || (profile.roleLevel==3)" to="/meeting"
                       dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Meeting.png"/>
            <span class="menu-item-saba-text">
                       نشست ها
                   </span>
          </v-list-item>
          <v-list-item v-if="(profile.roleLevel==1) || (profile.roleLevel==2) || (profile.roleLevel==3)" to="/report"
                       dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Report.png"/>
            <span class="menu-item-saba-text">
                       گزارش های کارشناسی
                   </span>
          </v-list-item>
          <v-list-item to="/letter" dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Correspondence.png"/>
            <span class="menu-item-saba-text">
                       مکاتبات
                   </span>
          </v-list-item>
          <v-list-item to="/message" dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Message.png"/>
            <span class="menu-item-saba-text">
                       پیامها
                   </span>
          </v-list-item>
          <v-list-item v-if="profile.roleLevel==1" to="/user" dense active-class="menu-active" class="menu-item-saba">
            <img class="menu-item-saba-icon" src="../assets/image/Icons/Users.png"/>
            <span class="menu-item-saba-text">
                       کاربران
                   </span>
          </v-list-item>

        </div>


        <br>


      </v-col>
      <v-col v-if="$store.state.userId" lg="9" sm="6" cols="12">

        <slot></slot>


      </v-col>
      <v-col v-else>
        <slot></slot>
      </v-col>
    </v-row>


  </div>

</template>

<script>

import {mdiCogOutline, mdiBellRingOutline, mdiPower} from "@mdi/js"
import {mapGetters} from 'vuex';
import ProfileForm from "./ProfileForm"
import axios from "axios"

export default {

  created() {
    this.getProfileData();
    this.fetchUnReadMessages();
  },

  data() {
    return {
      unreadmessages : 0,
      profile: {},
      profileLoaded: false,
      icons: {mdiCogOutline, mdiBellRingOutline, mdiPower}

    }
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$store.state.userId = null;
      this.$store.state.userRole = null;
      this.$store.state.userPost = null;
      this.$router.push('/add');
    },

    fetchUnReadMessages(){
      axios.post(this.$store.state.api + 'unreadmessages', {userId: this.$store.state.userId}).then(response => {
        this.unreadmessages = parseInt(response.data.data);
      });
    },


    getProfileData() {
      this.profileLoaded = false;
      axios.get(this.$store.state.api + 'drawerinfo', {
        params: {
          userId: this.$store.state.userId,
        }
      }).then(response => {
        if (response.data.data) {

          this.profile = response.data.data;
          localStorage.setItem('role', this.profile.role);
          this.$store.state.userRole = this.profile.role;
          localStorage.setItem('post', this.profile.post);
          this.$store.state.userPost = this.profile.post;
          localStorage.setItem('level', this.profile.roleLevel);
          this.$store.state.userLevel = this.profile.roleLevel;
          this.profileLoaded = true;
        } else {
          this.logout();
        }
      });
    }

  },
  components: {ProfileForm},
  computed: {
    ...mapGetters(['fetchProfileState'])
    /**
     * @return {boolean}
     */

  },
  watch: {
    fetchProfileState() {
      if (this.$store.state.fetchProfile) {
        this.getProfileData();
        this.$store.state.fetchProfile = false;
      }
    }
  }
}
</script>

<style scoped>


.v-list-item--active {
  border-left: 5px #4abbcb solid;
  color: #444;
}

.avatar-saba {
  width: 60%;
  border-radius: 50%;
  border: 1px solid #4abbcb;
  margin-top: 20px;
}

.right-menu-saba {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #ddd;
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 15px;
  padding-bottom: 40px;
}

.top-App-bar-saba {
  box-shadow: 0px 0px 10px #ddd !important;
  height: 72px !important;
  padding: 5px !important;
}

@media screen and (max-width: 1000px) {
  .menuText {
    margin-top: 10px;
    font-size: 0.8em;
    display: block;
  }

}

.singleMenu {
  margin-top: auto;
  margin-bottom: auto;
}

@media screen and (max-width: 800px) {
  .menuText {
    margin-top: 7px;
    font-size: 0.8em;
    display: block;
  }

  .logo {
    height: 60px !important;
  }

  .maim-menu {
    height: 60px !important;
  }
}


@media screen and (max-width: 600px) {

  .menuText {
    margin-top: 5px;

    font-size: 0.8em;

  }

}


.menuText {
  vertical-align: top;
  top: 5px;
}

.maim-menu {
  position: relative;
  margin-right: auto;
  margin-left: auto;
  max-width: 1000px;
  display: flex;
  justify-content: space-around;
  align-items: start;
  z-index: 10;
  height: 100px;
  margin-top: 0px;
}

.maim-menu a {
  color: #fff;
}

.logo {
  height: 100px;
}

.Drawer {
  z-index: 10000000;
}

.v-list-item__title {
  font-size: 1em !important;
  margin: 20px;
}


.activeLink {
  background-color: #08130a;
  color: #ffffff;
}

.DrawerLogo {
  width: 70%;
}


.menutitle {


  padding: 10px 20px;
  border-bottom: 1px #222 solid;
  border-top: 1px #222 solid;
  margin: 10px auto;
  font-size: 12px;
  color: #777;
  background-color: #222;

}

.topNav {
  width: 100%;
  background-color: #4c4d4b;
  border-bottom: 1px solid #fff;
  padding: 5px;
  color: #fff;

  text-align: right;

}

.topNav a {
  color: #eee;
}

.top-logo-saba {
  height: 62px;
  margin-right: 20px;
}

.logo-text-saba {
  color: #4abbcb;
  padding: 15px 5px;
  vertical-align: bottom;
  height: 70px;
}

.logo-text-saba a {
  color: #4abbcb;
}


.menu-item-saba {
  padding-right: 5px;
  display: flex;
  margin-top: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.menu-active {
  border-left: 5px #4abbcb solid;
}

.menu-item-saba-icon {
  margin-right: 10px;
  margin-left: 10px;
  width: 25px;
}

.menu-item-saba-text {

  margin-top: 5px;

}

.left-top-header {
  display: flex;
  padding-left: 20px;
}

.header-icon {

  top: 2px;
  margin-right: 15px;
}

.header-btn {
  border-radius: 10px;
  box-shadow: none !important;
}

</style>